import { DatePickerDemo } from '../../../components/ui/date-picker'
import type { FormProps } from '../../types'
import { useState } from 'react'
import { useController } from 'react-hook-form'

export interface CustomDateInput {
  name: string
  type: string
  customControlType: 'dateInput'
  minDate?: Date
  maxDate?: Date
  validation?: {
    required?: boolean
    minLength?: number
    maxLength?: number
    pattern?: string
    min?: number
    max?: number
    step?: number
  }
  uiOptions?: {
    testId?: string
  }
}

export type CustomDateProps = {
  field: CustomDateInput
  formProps: FormProps
}

export default function CustomDate({ field, formProps }: CustomDateProps) {
  const [dateValue, setDateValue] = useState<string | undefined>(
    formProps.formValues[field.name],
  )

  const {
    field: { onChange, ref },
  } = useController({
    control: formProps.control,
    name: field.name,
  })

  return (
    <div
      data-testid={field.name}
      className="date-picker-container"
      ref={ref}
    >
      <DatePickerDemo
        value={dateValue || formProps.formValues[field.name]}
        setValue={(d) => {
          setDateValue(d)
          onChange(d.substring(0, 10))
        }}
        minDate={field.minDate}
        maxDate={field.maxDate}
      />
    </div>
  )
}
